import { compact, uniqBy } from 'lodash-es'
import { useMemo } from 'react'
import { useInfiniteListArtworks } from 'src/services/apollo/artwork'
import type {
  ListArtworksQueryVariables,
  Media,
} from 'src/services/apollo/generated/graphql'
import { getNodesFromConnection } from 'src/utils/graphql'
import type { MediaPickerDataSource } from './MediaPicker'

export type UseModelArtworkDataSourceOptions = ListArtworksQueryVariables

/**
 * Hook that provides a data source from model or model version's artwork feed
 * This hook fetches artworks that were created using a specific model or model version
 */
export function useModelArtworkDataSource(
  options: UseModelArtworkDataSourceOptions,
): MediaPickerDataSource {
  const { data, loading, loadingMore, fetchMore } =
    useInfiniteListArtworks(options)

  const items = useMemo(() => {
    return uniqBy(
      compact(
        getNodesFromConnection(data)
          .filter(artwork => artwork.mediaId)
          .map(artwork => artwork.media as Media),
      ),
      'id',
    )
  }, [data])

  return {
    items,
    loading,
    loadingMore,
    hasMore: Boolean(data?.pageInfo.hasNextPage),
    fetchMore: () => {
      fetchMore({
        variables: {
          after: data?.pageInfo?.endCursor,
        },
      })
    },
  }
}
